import { Directive, Input, TemplateRef, inject } from '@angular/core';

/**
 * Marks the body template for one step. The host writes one per step
 * (`<ng-template appStepperStep="person">…</ng-template>`); the stepper renders the matching
 * template(s) for the current layout.
 */
@Directive({
  selector: '[appStepperStep]',
  standalone: true,
})
export class StepperStepDirective {
  @Input('appStepperStep') id!: string;
  readonly template = inject(TemplateRef<unknown>);
}
